
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class SandDunesEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, width, height } = pc;
        const curScale = config.parallaxScale || 1.0;
        
        ctx.fillStyle = pc.color;
        
        const draw = () => {
            ctx.beginPath();
            ctx.moveTo(-width * 2, height);
            const points = 20;
            const step = (width * 4) / points;
            
            for (let i = -points/2; i <= points/2; i++) {
                const x = i * step;
                const h = (layerIndex * 80 + Math.sin(x * 0.001 + layerIndex) * 100) * curScale;
                ctx.lineTo(x, height - h);
            }
            
            ctx.lineTo(width * 2, height);
            ctx.fill();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
